
export { default as useAnimateInOutComponent } from "./hooks/useAnimateInOutComponent"